import { jsx as c, jsxs as b, Fragment as ze } from "react/jsx-runtime";
import { useState as P, useEffect as I, useMemo as k, useRef as ge, useCallback as be } from "react";
const We = () => /* @__PURE__ */ c("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ c(
  "path",
  {
    className: "minus-icon",
    d: "M5.625 10.875C5.32663 10.875 5.04048 10.9935 4.8295 11.2045C4.61853 11.4155 4.5 11.7016 4.5 12C4.5 12.2984 4.61853 12.5845 4.8295 12.7955C5.04048 13.0065 5.32663 13.125 5.625 13.125H18.375C18.6734 13.125 18.9595 13.0065 19.1705 12.7955C19.3815 12.5845 19.5 12.2984 19.5 12C19.5 11.7016 19.3815 11.4155 19.1705 11.2045C18.9595 10.9935 18.6734 10.875 18.375 10.875H5.625Z",
    fill: "#7994C1"
  }
) }), Je = () => /* @__PURE__ */ c("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ c(
  "path",
  {
    className: "launch-icon",
    d: "M10 6H6C5.46957 6 4.96086 6.21071 4.58579 6.58579C4.21071 6.96086 4 7.46957 4 8V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V14M14 4H20M20 4V10M20 4L10 14",
    stroke: "#7994C1",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
) }), Ge = () => /* @__PURE__ */ b("svg", { width: "29", height: "28", viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ c("rect", { x: "0.449219", width: "28", height: "28", rx: "4", fill: "#1C8CF3" }),
  /* @__PURE__ */ c(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.74201 13.707C7.55453 13.5195 7.44922 13.2652 7.44922 13C7.44922 12.7349 7.55453 12.4806 7.74201 12.293L13.742 6.29303C13.9295 6.10556 14.1838 6.00024 14.449 6.00024C14.7142 6.00024 14.9685 6.10556 15.156 6.29303L21.156 12.293C21.3382 12.4816 21.439 12.7342 21.4367 12.9964C21.4344 13.2586 21.3292 13.5094 21.1438 13.6948C20.9584 13.8803 20.7076 13.9854 20.4454 13.9877C20.1832 13.99 19.9306 13.8892 19.742 13.707L15.449 9.41403V21C15.449 21.2652 15.3436 21.5196 15.1561 21.7071C14.9686 21.8947 14.7142 22 14.449 22C14.1838 22 13.9294 21.8947 13.7419 21.7071C13.5544 21.5196 13.449 21.2652 13.449 21V9.41403L9.156 13.707C8.96848 13.8945 8.71417 13.9998 8.44901 13.9998C8.18384 13.9998 7.92953 13.8945 7.74201 13.707Z",
      fill: "white"
    }
  )
] }), Ke = ({ style: e }) => /* @__PURE__ */ b(
  "svg",
  {
    style: { ...e && e },
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ c(
        "path",
        {
          d: "M49.8281 62.0881L65.3652 65.5415L61.9119 50.0043C64.1861 45.7504 65.3725 40.9999 65.3652 36.1763C65.3652 19.9578 52.2184 6.81104 36 6.81104C19.7816 6.81104 6.63477 19.9578 6.63477 36.1763C6.63477 52.3947 19.7816 65.5415 36 65.5415C40.8236 65.5487 45.5742 64.3624 49.8281 62.0881Z",
          fill: "#1C8CF3",
          stroke: "#1C8CF3",
          strokeWidth: "1.3",
          strokeLinejoin: "bevel"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M49.9863 36.9454C49.3068 36.9454 48.7559 36.3945 48.7559 35.7149V24.2305C48.7559 23.551 49.3068 23.0001 49.9863 23.0001C50.6659 23.0001 51.2168 23.551 51.2168 24.2305V35.7149C51.2168 36.3945 50.6659 36.9454 49.9863 36.9454Z",
          fill: "#021C39"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M22.0137 36.9454C21.3341 36.9454 20.7832 36.3945 20.7832 35.7149V24.2305C20.7832 23.551 21.3341 23.0001 22.0137 23.0001C22.6932 23.0001 23.2441 23.551 23.2441 24.2305V35.7149C23.2441 36.3945 22.6932 36.9454 22.0137 36.9454Z",
          fill: "#021C39"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M24.1211 33.5493H19.6914C17.656 33.5493 16 35.2052 16 37.2407V42.2446C16 44.28 17.656 45.936 19.6914 45.936H24.1211C24.8006 45.936 25.3516 45.3851 25.3516 44.7055V34.7797C25.3516 34.1002 24.8006 33.5493 24.1211 33.5493Z",
          fill: "#021C39"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M52.6602 33.5493H48.2305C47.5509 33.5493 47 34.1002 47 34.7797V44.7055C47 45.3851 47.5509 45.936 48.2305 45.936H52.6602C54.6956 45.936 56.3516 44.28 56.3516 42.2446V37.2407C56.3516 35.2052 54.6956 33.5493 52.6602 33.5493Z",
          fill: "#021C39"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M47.3548 27.8053C44.3299 24.8324 40.2974 23.1951 36 23.1951C31.6995 23.1951 27.6656 24.8326 24.6417 27.8059C21.5981 30.7984 19.9219 34.8128 19.9219 39.1094V41.4879C19.9219 45.9659 23.5651 49.6092 28.0432 49.6092H43.9568C48.435 49.6092 52.0781 45.9659 52.0781 41.4879V39.1094C52.0781 34.8132 50.4007 30.7987 47.3548 27.8053Z",
          fill: "#EAF3FF"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M41.2154 30.3658H30.785C26.6001 30.3658 23.1953 33.8123 23.1953 38.0488C23.1953 42.2851 26.6 45.7317 30.785 45.7317H41.2154C45.4003 45.7317 48.8051 42.2852 48.8051 38.0488C48.8051 33.8123 45.4003 30.3658 41.2154 30.3658Z",
          fill: "#B7D5F4"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M41.9868 31.3903H30.0116C26.8255 31.3903 24.2188 34.3866 24.2188 38.0488C24.2188 41.711 26.8255 44.7073 30.0116 44.7073H41.9868C45.1729 44.7073 47.7797 41.7111 47.7797 38.0488C47.7797 34.3865 45.1729 31.3903 41.9868 31.3903Z",
          fill: "#00429D"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M31.2285 40.2576C30.549 40.2576 29.998 39.7066 29.998 39.0271V38.1248C29.998 37.4452 30.549 36.8943 31.2285 36.8943C31.9081 36.8943 32.459 37.4452 32.459 38.1248V39.0271C32.459 39.7066 31.9081 40.2576 31.2285 40.2576Z",
          fill: "#EAF3FF"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M40.7715 40.2576C40.0919 40.2576 39.541 39.7066 39.541 39.0271V38.1248C39.541 37.4452 40.0919 36.8943 40.7715 36.8943C41.451 36.8943 42.002 37.4452 42.002 38.1248V39.0271C42.002 39.7066 41.451 40.2576 40.7715 40.2576Z",
          fill: "#EAF3FF"
        }
      )
    ]
  }
), Xe = ({ style: e }) => /* @__PURE__ */ b(
  "svg",
  {
    style: { ...e && e },
    width: "24",
    height: "23",
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ c("rect", { width: "23.372", height: "23", rx: "11.5", fill: "#1C8CF3" }),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M16.9473 11.7441C16.6884 11.7441 16.4785 11.5342 16.4785 11.2753V6.90033C16.4785 6.64145 16.6884 6.43158 16.9473 6.43158C17.2061 6.43158 17.416 6.64145 17.416 6.90033V11.2753C17.416 11.5342 17.2061 11.7441 16.9473 11.7441Z",
          fill: "#021C39"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M6.29102 11.7441C6.03214 11.7441 5.82227 11.5342 5.82227 11.2753V6.90033C5.82227 6.64145 6.03214 6.43158 6.29102 6.43158C6.54989 6.43158 6.75977 6.64145 6.75977 6.90033V11.2753C6.75977 11.5342 6.54989 11.7441 6.29102 11.7441Z",
          fill: "#021C39"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M7.09375 10.4503H5.40625C4.63084 10.4503 4 11.0812 4 11.8566V13.7628C4 14.5382 4.63084 15.1691 5.40625 15.1691H7.09375C7.35262 15.1691 7.5625 14.9592 7.5625 14.7003V10.9191C7.5625 10.6602 7.35262 10.4503 7.09375 10.4503Z",
          fill: "#021C39"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M17.9648 10.4503H16.2773C16.0185 10.4503 15.8086 10.6602 15.8086 10.9191V14.7003C15.8086 14.9592 16.0185 15.1691 16.2773 15.1691H17.9648C18.7403 15.1691 19.3711 14.5382 19.3711 13.7628V11.8566C19.3711 11.0812 18.7403 10.4503 17.9648 10.4503Z",
          fill: "#021C39"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M15.9448 8.26217C14.7924 7.12964 13.2562 6.50592 11.6191 6.50592C9.98086 6.50592 8.44414 7.1297 7.29217 8.26239C6.1327 9.40242 5.49414 10.9317 5.49414 12.5685V13.4746C5.49414 15.1805 6.88205 16.5684 8.58798 16.5684H14.6503C16.3563 16.5684 17.7441 15.1805 17.7441 13.4746V12.5685C17.7441 10.9319 17.1051 9.40251 15.9448 8.26217Z",
          fill: "#EAF3FF"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M13.605 9.23761H9.63153C8.03728 9.23761 6.74023 10.5506 6.74023 12.1644C6.74023 13.7783 8.03725 15.0913 9.63153 15.0913H13.605C15.1993 15.0913 16.4963 13.7783 16.4963 12.1644C16.4963 10.5506 15.1993 9.23761 13.605 9.23761Z",
          fill: "#B7D5F4"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.8997 9.62787H9.33767C8.12393 9.62787 7.13086 10.7693 7.13086 12.1645C7.13086 13.5596 8.12393 14.701 9.33767 14.701H13.8997C15.1134 14.701 16.1065 13.5596 16.1065 12.1645C16.1065 10.7693 15.1134 9.62787 13.8997 9.62787Z",
          fill: "#00429D"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M9.80078 13.0059C9.54191 13.0059 9.33203 12.796 9.33203 12.5371V12.1934C9.33203 11.9345 9.54191 11.7246 9.80078 11.7246C10.0597 11.7246 10.2695 11.9345 10.2695 12.1934V12.5371C10.2695 12.796 10.0597 13.0059 9.80078 13.0059Z",
          fill: "#EAF3FF"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M13.4375 13.0059C13.1786 13.0059 12.9688 12.796 12.9688 12.5371V12.1934C12.9688 11.9345 13.1786 11.7246 13.4375 11.7246C13.6964 11.7246 13.9062 11.9345 13.9062 12.1934V12.5371C13.9062 12.796 13.6964 13.0059 13.4375 13.0059Z",
          fill: "#EAF3FF"
        }
      )
    ]
  }
), Ee = ({ style: e }) => /* @__PURE__ */ c(
  "svg",
  {
    style: { ...e && e },
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ c(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.2008 14.7501C25.2008 17.7205 24.0208 20.5693 21.9204 22.6697C19.82 24.7701 16.9712 25.9501 14.0008 25.9501C11.0304 25.9501 8.18159 24.7701 6.08119 22.6697C3.98078 20.5693 2.80078 17.7205 2.80078 14.7501C2.80078 11.7797 3.98078 8.93092 6.08119 6.83051C8.18159 4.73011 11.0304 3.55011 14.0008 3.55011C16.9712 3.55011 19.82 4.73011 21.9204 6.83051C24.0208 8.93092 25.2008 11.7797 25.2008 14.7501ZM16.8008 10.5501C16.8008 11.2927 16.5058 12.0049 15.9807 12.53C15.4556 13.0551 14.7434 13.3501 14.0008 13.3501C13.2582 13.3501 12.546 13.0551 12.0209 12.53C11.4958 12.0049 11.2008 11.2927 11.2008 10.5501C11.2008 9.8075 11.4958 9.09531 12.0209 8.57021C12.546 8.04511 13.2582 7.75011 14.0008 7.75011C14.7434 7.75011 15.4556 8.04511 15.9807 8.57021C16.5058 9.09531 16.8008 9.8075 16.8008 10.5501ZM14.0008 16.1501C12.6604 16.1498 11.3482 16.5344 10.22 17.2581C9.09176 17.9818 8.19504 19.0141 7.63638 20.2325C8.42413 21.149 9.40076 21.8842 10.4993 22.3878C11.5978 22.8914 12.7923 23.1514 14.0008 23.1501C15.2093 23.1514 16.4037 22.8914 17.5023 22.3878C18.6008 21.8842 19.5774 21.149 20.3652 20.2325C19.8065 19.0141 18.9098 17.9818 17.7816 17.2581C16.6534 16.5344 15.3411 16.1498 14.0008 16.1501Z",
        fill: "#7994C1"
      }
    )
  }
), Qe = ({ style: e }) => /* @__PURE__ */ b(
  "svg",
  {
    style: { ...e && e },
    width: "50",
    height: "32",
    viewBox: "0 0 50 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "",
    children: [
      /* @__PURE__ */ c("rect", { width: "50", height: "32", rx: "16", className: "typing-icon" }),
      /* @__PURE__ */ c("circle", { className: "typing-first-dot", cx: "18", cy: "16", r: "2", fill: "#7994C1" }),
      /* @__PURE__ */ c("circle", { className: "typing-second-dot", cx: "25", cy: "16", r: "2", fill: "#7994C1" }),
      /* @__PURE__ */ c("circle", { className: "typing-third-dot", cx: "32", cy: "16", r: "2", fill: "#7994C1" })
    ]
  }
), Ye = ({ style: e }) => /* @__PURE__ */ c(
  "svg",
  {
    style: { ...e && e },
    width: "14",
    height: "13",
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ c(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.3996 6.49998C13.3996 8.19736 12.7253 9.82523 11.5251 11.0255C10.3249 12.2257 8.69699 12.9 6.99961 12.9C5.30222 12.9 3.67436 12.2257 2.47413 11.0255C1.27389 9.82523 0.599609 8.19736 0.599609 6.49998C0.599609 4.80259 1.27389 3.17473 2.47413 1.97449C3.67436 0.77426 5.30222 0.0999756 6.99961 0.0999756C8.69699 0.0999756 10.3249 0.77426 11.5251 1.97449C12.7253 3.17473 13.3996 4.80259 13.3996 6.49998ZM7.79961 3.29998C7.79961 3.51215 7.71532 3.71563 7.56529 3.86566C7.41527 4.01569 7.21178 4.09998 6.99961 4.09998C6.78744 4.09998 6.58395 4.01569 6.43392 3.86566C6.2839 3.71563 6.19961 3.51215 6.19961 3.29998C6.19961 3.0878 6.2839 2.88432 6.43392 2.73429C6.58395 2.58426 6.78744 2.49998 6.99961 2.49998C7.21178 2.49998 7.41527 2.58426 7.56529 2.73429C7.71532 2.88432 7.79961 3.0878 7.79961 3.29998ZM6.19961 5.69998C5.98744 5.69998 5.78395 5.78426 5.63392 5.93429C5.4839 6.08432 5.39961 6.2878 5.39961 6.49998C5.39961 6.71215 5.4839 6.91563 5.63392 7.06566C5.78395 7.21569 5.98744 7.29998 6.19961 7.29998V9.69998C6.19961 9.91215 6.2839 10.1156 6.43392 10.2657C6.58395 10.4157 6.78744 10.5 6.99961 10.5H7.79961C8.01178 10.5 8.21527 10.4157 8.36529 10.2657C8.51532 10.1156 8.59961 9.91215 8.59961 9.69998C8.59961 9.4878 8.51532 9.28432 8.36529 9.13429C8.21527 8.98426 8.01178 8.89998 7.79961 8.89998V6.49998C7.79961 6.2878 7.71532 6.08432 7.56529 5.93429C7.41527 5.78426 7.21178 5.69998 6.99961 5.69998H6.19961Z",
        fill: "#D54040"
      }
    )
  }
), et = ({ style: e }) => /* @__PURE__ */ b(
  "svg",
  {
    style: { ...e && e },
    className: "loading-icon",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ c(
        "path",
        {
          d: "M7.71805 0.719375C7.71805 0.861653 7.67585 1.00073 7.59681 1.11903C7.51776 1.23733 7.40541 1.32953 7.27396 1.38398C7.14252 1.43843 6.99787 1.45266 6.85833 1.4249C6.71878 1.39715 6.5906 1.32865 6.49 1.22805C6.38939 1.12744 6.32087 0.999261 6.29312 0.859717C6.26536 0.720173 6.27962 0.575517 6.33406 0.44407C6.38851 0.312622 6.48071 0.200282 6.59901 0.121236C6.71731 0.0421909 6.85639 0 6.99867 0C7.18946 0 7.37244 0.0757931 7.50734 0.210701C7.64225 0.345609 7.71805 0.528586 7.71805 0.719375Z",
          fill: "#1C8CF3"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.65",
          d: "M7.71805 13.2802C7.71805 13.4225 7.67585 13.5616 7.59681 13.6799C7.51776 13.7982 7.40541 13.8904 7.27396 13.9448C7.14252 13.9993 6.99787 14.0135 6.85833 13.9858C6.71878 13.958 6.5906 13.8895 6.49 13.7889C6.38939 13.6883 6.32087 13.5601 6.29312 13.4206C6.26536 13.281 6.27962 13.1364 6.33406 13.0049C6.38851 12.8735 6.48071 12.7611 6.59901 12.6821C6.71731 12.603 6.85639 12.5609 6.99867 12.5609C7.18944 12.5609 7.37239 12.6367 7.50729 12.7716C7.64218 12.9065 7.71799 13.0895 7.71805 13.2802Z",
          fill: "#1C8CF3"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.45",
          d: "M13.2822 7.71927C13.1399 7.71931 13.0008 7.67714 12.8824 7.59809C12.764 7.51903 12.6718 7.40665 12.6173 7.27516C12.5628 7.14367 12.5486 6.99897 12.5763 6.85937C12.6041 6.71977 12.6726 6.59154 12.7732 6.49089C12.8739 6.39025 13.0021 6.32173 13.1417 6.29397C13.2813 6.26621 13.426 6.28048 13.5575 6.33496C13.689 6.38945 13.8014 6.48169 13.8804 6.60005C13.9595 6.71842 14.0017 6.85757 14.0016 6.9999C14.0016 7.19067 13.9258 7.37363 13.7909 7.50853C13.656 7.64342 13.473 7.71922 13.2822 7.71927Z",
          fill: "#1C8CF3"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.8",
          d: "M0.71956 7.71928C0.577235 7.71928 0.438111 7.67707 0.319775 7.598C0.201439 7.51892 0.109209 7.40654 0.0547529 7.27505C0.000296511 7.14355 -0.0139387 6.99884 0.0138415 6.85926C0.0416217 6.71967 0.110163 6.59146 0.210815 6.49083C0.311467 6.3902 0.439706 6.32169 0.579301 6.29395C0.718895 6.26621 0.863574 6.2805 0.995054 6.33499C1.12653 6.38948 1.2389 6.48173 1.31795 6.60008C1.39699 6.71844 1.43916 6.85758 1.43912 6.9999C1.43907 7.19071 1.36324 7.3737 1.2283 7.5086C1.09337 7.6435 0.910367 7.71928 0.71956 7.71928Z",
          fill: "#1C8CF3"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.35",
          d: "M11.9511 3.0678C11.8505 3.16845 11.7222 3.237 11.5827 3.26477C11.4431 3.29255 11.2984 3.27831 11.1669 3.22385C11.0354 3.16939 10.923 3.07716 10.8439 2.95883C10.7649 2.8405 10.7227 2.70136 10.7227 2.55903C10.7227 2.41671 10.7649 2.27759 10.8439 2.15926C10.923 2.04092 11.0354 1.9487 11.1669 1.89424C11.2984 1.83978 11.4431 1.82554 11.5827 1.85331C11.7222 1.88109 11.8505 1.94964 11.9511 2.05029C12.086 2.18523 12.1618 2.36822 12.1618 2.55903C12.1618 2.74985 12.086 2.93286 11.9511 3.0678Z",
          fill: "#1C8CF3"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.7",
          d: "M3.06632 11.9495C2.96569 12.0502 2.83748 12.1187 2.69789 12.1465C2.5583 12.1742 2.41362 12.16 2.28213 12.1055C2.15063 12.0511 2.03825 11.9589 1.95917 11.8405C1.8801 11.7222 1.83789 11.5831 1.83789 11.4407C1.83789 11.2984 1.8801 11.1593 1.95917 11.041C2.03825 10.9226 2.15063 10.8304 2.28213 10.776C2.41362 10.7215 2.5583 10.7073 2.69789 10.735C2.83748 10.7628 2.96569 10.8313 3.06632 10.932C3.20123 11.0669 3.27702 11.2499 3.27702 11.4407C3.27702 11.6316 3.20123 11.8146 3.06632 11.9495Z",
          fill: "#1C8CF3"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.55",
          d: "M10.9335 11.9496C10.8328 11.8489 10.7643 11.7207 10.7365 11.5811C10.7087 11.4415 10.723 11.2969 10.7774 11.1654C10.8319 11.0339 10.9241 10.9215 11.0424 10.8424C11.1608 10.7633 11.2999 10.7211 11.4422 10.7211C11.5845 10.7211 11.7237 10.7633 11.842 10.8424C11.9603 10.9215 12.0526 11.0339 12.107 11.1654C12.1615 11.2969 12.1757 11.4415 12.148 11.5811C12.1202 11.7207 12.0516 11.8489 11.951 11.9496C11.8842 12.0164 11.8049 12.0694 11.7176 12.1055C11.6303 12.1417 11.5367 12.1603 11.4422 12.1603C11.3477 12.1603 11.2542 12.1417 11.1669 12.1055C11.0796 12.0694 11.0003 12.0164 10.9335 11.9496Z",
          fill: "#1C8CF3"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.9",
          d: "M2.55745 3.27861C2.95486 3.27861 3.27702 2.95645 3.27702 2.55904C3.27702 2.16164 2.95486 1.83948 2.55745 1.83948C2.16005 1.83948 1.83789 2.16164 1.83789 2.55904C1.83789 2.95645 2.16005 3.27861 2.55745 3.27861Z",
          fill: "#1C8CF3"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.2",
          d: "M10.0527 1.46442C9.99855 1.59599 9.90664 1.70855 9.78856 1.78789C9.67048 1.86723 9.53152 1.90978 9.38926 1.91016C9.247 1.91054 9.10782 1.86872 8.98932 1.79001C8.87082 1.7113 8.7783 1.59921 8.7235 1.46793C8.66869 1.33665 8.65404 1.19208 8.68139 1.05247C8.70875 0.912867 8.77689 0.784511 8.87719 0.683623C8.97749 0.582734 9.10544 0.513854 9.24488 0.485682C9.38433 0.45751 9.529 0.471317 9.6606 0.525355C9.74802 0.561252 9.82752 0.614 9.89454 0.680627C9.96155 0.747254 10.0148 0.826435 10.0512 0.913641C10.0876 1.00085 10.1065 1.09437 10.1067 1.18888C10.107 1.28338 10.0886 1.37702 10.0527 1.46442Z",
          fill: "#1C8CF3"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.7",
          d: "M5.27972 13.0826C5.22565 13.2143 5.13375 13.327 5.01565 13.4064C4.89755 13.4858 4.75855 13.5284 4.61622 13.5288C4.47389 13.5293 4.33464 13.4875 4.21607 13.4087C4.0975 13.33 4.00493 13.2179 3.95009 13.0865C3.89525 12.9552 3.88059 12.8106 3.90797 12.6709C3.93534 12.5312 4.00351 12.4028 4.10387 12.3019C4.20423 12.201 4.33227 12.1321 4.47179 12.1039C4.6113 12.0758 4.75603 12.0896 4.88767 12.1438C5.06414 12.2163 5.20457 12.356 5.27809 12.532C5.35161 12.7081 5.3522 12.9061 5.27972 13.0826Z",
          fill: "#1C8CF3"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.5",
          d: "M12.5361 10.0528C12.4044 9.99871 12.2917 9.90683 12.2123 9.78872C12.1329 9.67062 12.0903 9.53161 12.0898 9.38928C12.0894 9.24695 12.1312 9.1077 12.21 8.98913C12.2887 8.87056 12.4008 8.77801 12.5321 8.72316C12.6635 8.66832 12.8081 8.65366 12.9478 8.68104C13.0875 8.70841 13.2159 8.77659 13.3168 8.87695C13.4177 8.97731 13.4866 9.10534 13.5148 9.24486C13.5429 9.38437 13.529 9.5291 13.4749 9.66074C13.4024 9.83721 13.2627 9.97763 13.0867 10.0511C12.9106 10.1247 12.7126 10.1253 12.5361 10.0528Z",
          fill: "#1C8CF3"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.85",
          d: "M0.916627 5.2778C0.785034 5.22372 0.672435 5.13185 0.593063 5.01377C0.51369 4.8957 0.471107 4.75674 0.470706 4.61447C0.470305 4.4722 0.512105 4.333 0.59081 4.21448C0.669516 4.09597 0.781591 4.00344 0.912877 3.94861C1.04416 3.89379 1.18876 3.87914 1.32838 3.90649C1.468 3.93384 1.59636 4.00197 1.69726 4.10228C1.79815 4.20259 1.86704 4.33057 1.89521 4.47002C1.92338 4.60948 1.90956 4.75416 1.8555 4.88577C1.8196 4.97316 1.76684 5.05263 1.70023 5.11963C1.63362 5.18663 1.55446 5.23984 1.46727 5.27625C1.38009 5.31265 1.28658 5.33153 1.1921 5.33179C1.09762 5.33206 1.00402 5.31372 0.916627 5.2778Z",
          fill: "#1C8CF3"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.4",
          d: "M13.0733 5.24449C12.942 5.29938 12.7973 5.3141 12.6576 5.28678C12.5179 5.25946 12.3895 5.19135 12.2885 5.09103C12.1876 4.99071 12.1186 4.8627 12.0904 4.7232C12.0622 4.58369 12.0761 4.43895 12.1301 4.30729C12.1842 4.17563 12.276 4.06295 12.3941 3.98351C12.5122 3.90408 12.6513 3.86145 12.7936 3.86103C12.9359 3.8606 13.0752 3.90241 13.1937 3.98113C13.3123 4.05985 13.4049 4.17197 13.4597 4.3033C13.5333 4.47936 13.5338 4.67742 13.4614 4.85391C13.3889 5.03041 13.2493 5.1709 13.0733 5.24449Z",
          fill: "#1C8CF3"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.75",
          d: "M1.47952 10.0834C1.34821 10.1383 1.20356 10.153 1.06387 10.1256C0.924194 10.0983 0.79576 10.0302 0.6948 9.9299C0.593839 9.82958 0.524898 9.70157 0.496694 9.56206C0.468489 9.42256 0.482284 9.27782 0.536343 9.14616C0.590402 9.0145 0.682287 8.90181 0.800386 8.82238C0.918485 8.74295 1.05749 8.70032 1.19982 8.69989C1.34214 8.69947 1.48141 8.74128 1.59998 8.82C1.71855 8.89872 1.81112 9.01084 1.86597 9.14217C1.9024 9.22934 1.9213 9.32283 1.9216 9.41731C1.9219 9.51179 1.90358 9.60541 1.86769 9.69281C1.8318 9.78021 1.77906 9.85968 1.71245 9.92669C1.64585 9.9937 1.5667 10.0469 1.47952 10.0834Z",
          fill: "#1C8CF3"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.6",
          d: "M8.75493 13.0729C8.70001 12.9416 8.68528 12.7969 8.71259 12.6573C8.7399 12.5176 8.80801 12.3891 8.90833 12.2881C9.00866 12.1872 9.13668 12.1182 9.2762 12.09C9.41571 12.0618 9.56046 12.0756 9.69213 12.1297C9.82379 12.1838 9.93648 12.2757 10.0159 12.3938C10.0953 12.5119 10.1379 12.6509 10.1383 12.7933C10.1387 12.9356 10.0969 13.0749 10.0182 13.1934C9.93941 13.312 9.82728 13.4045 9.69592 13.4594C9.51989 13.5329 9.32185 13.5335 9.14538 13.461C8.96892 13.3885 8.82848 13.2489 8.75493 13.0729Z",
          fill: "#1C8CF3"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.95",
          d: "M3.91496 1.48127C3.86012 1.34999 3.84544 1.20541 3.87278 1.06579C3.90011 0.926165 3.96823 0.797773 4.06852 0.696865C4.16882 0.595957 4.29678 0.527062 4.43623 0.498877C4.57568 0.470693 4.72036 0.484488 4.85197 0.538527C4.98358 0.592565 5.09622 0.684415 5.17563 0.802464C5.25504 0.920512 5.29766 1.05945 5.29811 1.20172C5.29855 1.34399 5.2568 1.48321 5.17813 1.60175C5.09946 1.7203 4.98742 1.81285 4.85615 1.86772C4.76897 1.90415 4.67548 1.92306 4.581 1.92336C4.48652 1.92365 4.39291 1.90532 4.30551 1.86944C4.21811 1.83355 4.13864 1.78082 4.07163 1.71421C4.00461 1.64761 3.95138 1.56845 3.91496 1.48127Z",
          fill: "#1C8CF3"
        }
      )
    ]
  }
);
function tt({ handleClose: e }) {
  return /* @__PURE__ */ b(
    "div",
    {
      className: "header-container",
      style: {
        height: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: "0px"
      },
      children: [
        /* @__PURE__ */ c(
          "p",
          {
            style: {
              fontWeight: 600,
              fontSize: 20,
              display: "flex",
              alignItems: "center"
            },
            children: "Trava GPT"
          }
        ),
        /* @__PURE__ */ b("div", { style: { display: "flex", alignItems: "center" }, children: [
          /* @__PURE__ */ c("button", { className: "icon-button", onClick: e, children: /* @__PURE__ */ c(We, {}) }),
          /* @__PURE__ */ c("a", { href: "/gpt", children: /* @__PURE__ */ c("button", { className: "icon-button", style: { marginLeft: 5 }, children: /* @__PURE__ */ c(Je, {}) }) })
        ] })
      ]
    }
  );
}
function nt({ message: e, state: t }) {
  const [n, r] = P(!1);
  return I(() => {
    r(!0);
  }, []), /* @__PURE__ */ b(
    "div",
    {
      className: `message-item ${n ? "slide-up" : ""}`,
      style: {
        display: "flex"
      },
      children: [
        /* @__PURE__ */ c(Ee, { style: { marginRight: "5px", marginTop: "12px", width: "30px", height: "30px" } }),
        /* @__PURE__ */ b(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center",
              paddingRight: "10px"
            },
            children: [
              /* @__PURE__ */ c("p", { style: { maxWidth: "280px", wordBreak: "break-all" }, children: e }),
              t === "FAILED" && /* @__PURE__ */ c(Ye, { style: { width: "12px", height: "12px", marginLeft: "5px" } })
            ]
          }
        )
      ]
    }
  );
}
function rt({
  message: e,
  animation: t,
  status: n,
  typingSpeed: r,
  onAnimationEnd: s,
  style: i
}) {
  const [o, u] = P([]), [h, f] = P(0);
  return I(() => {
    if (t) {
      const d = setInterval(() => {
        f((l) => l + 1);
      }, 1e3 / (r || 1));
      u((l) => [...l, Number(d)]);
    } else
      f(e.split(" ").length);
    return () => {
      for (const d of o)
        clearInterval(d);
    };
  }, [t, e, r]), I(() => {
    const d = e.split(" ");
    if (h >= d.length) {
      for (const l of o)
        clearInterval(l);
      t && s && s(), u([]);
    }
  }, [h, e, s]), /* @__PURE__ */ b("div", { style: { display: "flex", ...i && i }, children: [
    /* @__PURE__ */ c(
      Xe,
      {
        style: { marginRight: "6.5px", marginLeft: "2.5px", marginTop: "15px" }
      }
    ),
    /* @__PURE__ */ b("div", { style: { display: "flex", alignItems: "center" }, children: [
      n === "SUCCESS" && /* @__PURE__ */ c(
        "p",
        {
          style: {
            maxWidth: "280px",
            wordBreak: "break-all"
          },
          children: e.split(" ").slice(0, h).join(" ")
        }
      ),
      n === "PROCESSING" && /* @__PURE__ */ c(Qe, { style: { marginTop: "12px", marginBottom: "12px" } })
    ] })
  ] });
}
function xe(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: st } = Object.prototype, { getPrototypeOf: re } = Object, q = /* @__PURE__ */ ((e) => (t) => {
  const n = st.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), O = (e) => (e = e.toLowerCase(), (t) => q(t) === e), Z = (e) => (t) => typeof t === e, { isArray: M } = Array, _ = Z("undefined");
function it(e) {
  return e !== null && !_(e) && e.constructor !== null && !_(e.constructor) && S(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Se = O("ArrayBuffer");
function ot(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Se(e.buffer), t;
}
const at = Z("string"), S = Z("function"), Re = Z("number"), $ = (e) => e !== null && typeof e == "object", lt = (e) => e === !0 || e === !1, H = (e) => {
  if (q(e) !== "object")
    return !1;
  const t = re(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, ct = O("Date"), ut = O("File"), dt = O("Blob"), ft = O("FileList"), ht = (e) => $(e) && S(e.pipe), pt = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || S(e.append) && ((t = q(e)) === "formdata" || // detect form-data instance
  t === "object" && S(e.toString) && e.toString() === "[object FormData]"));
}, Ct = O("URLSearchParams"), mt = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function D(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, s;
  if (typeof e != "object" && (e = [e]), M(e))
    for (r = 0, s = e.length; r < s; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let u;
    for (r = 0; r < o; r++)
      u = i[r], t.call(null, e[u], u, e);
  }
}
function Oe(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, s;
  for (; r-- > 0; )
    if (s = n[r], t === s.toLowerCase())
      return s;
  return null;
}
const Ae = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Te = (e) => !_(e) && e !== Ae;
function Q() {
  const { caseless: e } = Te(this) && this || {}, t = {}, n = (r, s) => {
    const i = e && Oe(t, s) || s;
    H(t[i]) && H(r) ? t[i] = Q(t[i], r) : H(r) ? t[i] = Q({}, r) : M(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, s = arguments.length; r < s; r++)
    arguments[r] && D(arguments[r], n);
  return t;
}
const yt = (e, t, n, { allOwnKeys: r } = {}) => (D(t, (s, i) => {
  n && S(s) ? e[i] = xe(s, n) : e[i] = s;
}, { allOwnKeys: r }), e), wt = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), gt = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, bt = (e, t, n, r) => {
  let s, i, o;
  const u = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (s = Object.getOwnPropertyNames(e), i = s.length; i-- > 0; )
      o = s[i], (!r || r(o, e, t)) && !u[o] && (t[o] = e[o], u[o] = !0);
    e = n !== !1 && re(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Et = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, xt = (e) => {
  if (!e)
    return null;
  if (M(e))
    return e;
  let t = e.length;
  if (!Re(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, St = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && re(Uint8Array)), Rt = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let s;
  for (; (s = r.next()) && !s.done; ) {
    const i = s.value;
    t.call(e, i[0], i[1]);
  }
}, Ot = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, At = O("HTMLFormElement"), Tt = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, s) {
    return r.toUpperCase() + s;
  }
), le = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Ft = O("RegExp"), Fe = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  D(n, (s, i) => {
    let o;
    (o = t(s, i, e)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(e, r);
}, Nt = (e) => {
  Fe(e, (t, n) => {
    if (S(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (S(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Pt = (e, t) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return M(e) ? r(e) : r(String(e).split(t)), n;
}, Lt = () => {
}, Mt = (e, t) => (e = +e, Number.isFinite(e) ? e : t), J = "abcdefghijklmnopqrstuvwxyz", ce = "0123456789", Ne = {
  DIGIT: ce,
  ALPHA: J,
  ALPHA_DIGIT: J + J.toUpperCase() + ce
}, Bt = (e = 16, t = Ne.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function kt(e) {
  return !!(e && S(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const It = (e) => {
  const t = new Array(10), n = (r, s) => {
    if ($(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[s] = r;
        const i = M(r) ? [] : {};
        return D(r, (o, u) => {
          const h = n(o, s + 1);
          !_(h) && (i[u] = h);
        }), t[s] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, _t = O("AsyncFunction"), Dt = (e) => e && ($(e) || S(e)) && S(e.then) && S(e.catch), a = {
  isArray: M,
  isArrayBuffer: Se,
  isBuffer: it,
  isFormData: pt,
  isArrayBufferView: ot,
  isString: at,
  isNumber: Re,
  isBoolean: lt,
  isObject: $,
  isPlainObject: H,
  isUndefined: _,
  isDate: ct,
  isFile: ut,
  isBlob: dt,
  isRegExp: Ft,
  isFunction: S,
  isStream: ht,
  isURLSearchParams: Ct,
  isTypedArray: St,
  isFileList: ft,
  forEach: D,
  merge: Q,
  extend: yt,
  trim: mt,
  stripBOM: wt,
  inherits: gt,
  toFlatObject: bt,
  kindOf: q,
  kindOfTest: O,
  endsWith: Et,
  toArray: xt,
  forEachEntry: Rt,
  matchAll: Ot,
  isHTMLForm: At,
  hasOwnProperty: le,
  hasOwnProp: le,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Fe,
  freezeMethods: Nt,
  toObjectSet: Pt,
  toCamelCase: Tt,
  noop: Lt,
  toFiniteNumber: Mt,
  findKey: Oe,
  global: Ae,
  isContextDefined: Te,
  ALPHABET: Ne,
  generateString: Bt,
  isSpecCompliantForm: kt,
  toJSONObject: It,
  isAsyncFn: _t,
  isThenable: Dt
};
function m(e, t, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), s && (this.response = s);
}
a.inherits(m, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: a.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Pe = m.prototype, Le = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Le[e] = { value: e };
});
Object.defineProperties(m, Le);
Object.defineProperty(Pe, "isAxiosError", { value: !0 });
m.from = (e, t, n, r, s, i) => {
  const o = Object.create(Pe);
  return a.toFlatObject(e, o, function(h) {
    return h !== Error.prototype;
  }, (u) => u !== "isAxiosError"), m.call(o, e.message, t, n, r, s), o.cause = e, o.name = e.name, i && Object.assign(o, i), o;
};
const vt = null;
function Y(e) {
  return a.isPlainObject(e) || a.isArray(e);
}
function Me(e) {
  return a.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function ue(e, t, n) {
  return e ? e.concat(t).map(function(s, i) {
    return s = Me(s), !n && i ? "[" + s + "]" : s;
  }).join(n ? "." : "") : t;
}
function Ht(e) {
  return a.isArray(e) && !e.some(Y);
}
const jt = a.toFlatObject(a, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function z(e, t, n) {
  if (!a.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = a.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(C, g) {
    return !a.isUndefined(g[C]);
  });
  const r = n.metaTokens, s = n.visitor || d, i = n.dots, o = n.indexes, h = (n.Blob || typeof Blob < "u" && Blob) && a.isSpecCompliantForm(t);
  if (!a.isFunction(s))
    throw new TypeError("visitor must be a function");
  function f(p) {
    if (p === null)
      return "";
    if (a.isDate(p))
      return p.toISOString();
    if (!h && a.isBlob(p))
      throw new m("Blob is not supported. Use a Buffer instead.");
    return a.isArrayBuffer(p) || a.isTypedArray(p) ? h && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function d(p, C, g) {
    let x = p;
    if (p && !g && typeof p == "object") {
      if (a.endsWith(C, "{}"))
        C = r ? C : C.slice(0, -2), p = JSON.stringify(p);
      else if (a.isArray(p) && Ht(p) || (a.isFileList(p) || a.endsWith(C, "[]")) && (x = a.toArray(p)))
        return C = Me(C), x.forEach(function(F, $e) {
          !(a.isUndefined(F) || F === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? ue([C], $e, i) : o === null ? C : C + "[]",
            f(F)
          );
        }), !1;
    }
    return Y(p) ? !0 : (t.append(ue(g, C, i), f(p)), !1);
  }
  const l = [], y = Object.assign(jt, {
    defaultVisitor: d,
    convertValue: f,
    isVisitable: Y
  });
  function w(p, C) {
    if (!a.isUndefined(p)) {
      if (l.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + C.join("."));
      l.push(p), a.forEach(p, function(x, T) {
        (!(a.isUndefined(x) || x === null) && s.call(
          t,
          x,
          a.isString(T) ? T.trim() : T,
          C,
          y
        )) === !0 && w(x, C ? C.concat(T) : [T]);
      }), l.pop();
    }
  }
  if (!a.isObject(e))
    throw new TypeError("data must be an object");
  return w(e), t;
}
function de(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function se(e, t) {
  this._pairs = [], e && z(e, this, t);
}
const Be = se.prototype;
Be.append = function(t, n) {
  this._pairs.push([t, n]);
};
Be.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, de);
  } : de;
  return this._pairs.map(function(s) {
    return n(s[0]) + "=" + n(s[1]);
  }, "").join("&");
};
function Ut(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function ke(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || Ut, s = n && n.serialize;
  let i;
  if (s ? i = s(t, n) : i = a.isURLSearchParams(t) ? t.toString() : new se(t, n).toString(r), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class fe {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    a.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const Ie = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Vt = typeof URLSearchParams < "u" ? URLSearchParams : se, qt = typeof FormData < "u" ? FormData : null, Zt = typeof Blob < "u" ? Blob : null, $t = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Vt,
    FormData: qt,
    Blob: Zt
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, _e = typeof window < "u" && typeof document < "u", zt = ((e) => _e && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), Wt = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Jt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: _e,
  hasStandardBrowserEnv: zt,
  hasStandardBrowserWebWorkerEnv: Wt
}, Symbol.toStringTag, { value: "Module" })), R = {
  ...Jt,
  ...$t
};
function Gt(e, t) {
  return z(e, new R.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, s, i) {
      return R.isNode && a.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Kt(e) {
  return a.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Xt(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const s = n.length;
  let i;
  for (r = 0; r < s; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function De(e) {
  function t(n, r, s, i) {
    let o = n[i++];
    if (o === "__proto__")
      return !0;
    const u = Number.isFinite(+o), h = i >= n.length;
    return o = !o && a.isArray(s) ? s.length : o, h ? (a.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !u) : ((!s[o] || !a.isObject(s[o])) && (s[o] = []), t(n, r, s[o], i) && a.isArray(s[o]) && (s[o] = Xt(s[o])), !u);
  }
  if (a.isFormData(e) && a.isFunction(e.entries)) {
    const n = {};
    return a.forEachEntry(e, (r, s) => {
      t(Kt(r), s, n, 0);
    }), n;
  }
  return null;
}
function Qt(e, t, n) {
  if (a.isString(e))
    try {
      return (t || JSON.parse)(e), a.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const ie = {
  transitional: Ie,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", s = r.indexOf("application/json") > -1, i = a.isObject(t);
    if (i && a.isHTMLForm(t) && (t = new FormData(t)), a.isFormData(t))
      return s ? JSON.stringify(De(t)) : t;
    if (a.isArrayBuffer(t) || a.isBuffer(t) || a.isStream(t) || a.isFile(t) || a.isBlob(t))
      return t;
    if (a.isArrayBufferView(t))
      return t.buffer;
    if (a.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let u;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return Gt(t, this.formSerializer).toString();
      if ((u = a.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const h = this.env && this.env.FormData;
        return z(
          u ? { "files[]": t } : t,
          h && new h(),
          this.formSerializer
        );
      }
    }
    return i || s ? (n.setContentType("application/json", !1), Qt(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || ie.transitional, r = n && n.forcedJSONParsing, s = this.responseType === "json";
    if (t && a.isString(t) && (r && !this.responseType || s)) {
      const o = !(n && n.silentJSONParsing) && s;
      try {
        return JSON.parse(t);
      } catch (u) {
        if (o)
          throw u.name === "SyntaxError" ? m.from(u, m.ERR_BAD_RESPONSE, this, null, this.response) : u;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: R.classes.FormData,
    Blob: R.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
a.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  ie.headers[e] = {};
});
const oe = ie, Yt = a.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), e1 = (e) => {
  const t = {};
  let n, r, s;
  return e && e.split(`
`).forEach(function(o) {
    s = o.indexOf(":"), n = o.substring(0, s).trim().toLowerCase(), r = o.substring(s + 1).trim(), !(!n || t[n] && Yt[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, he = Symbol("internals");
function B(e) {
  return e && String(e).trim().toLowerCase();
}
function j(e) {
  return e === !1 || e == null ? e : a.isArray(e) ? e.map(j) : String(e);
}
function t1(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const n1 = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function G(e, t, n, r, s) {
  if (a.isFunction(r))
    return r.call(this, t, n);
  if (s && (t = n), !!a.isString(t)) {
    if (a.isString(r))
      return t.indexOf(r) !== -1;
    if (a.isRegExp(r))
      return r.test(t);
  }
}
function r1(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function s1(e, t) {
  const n = a.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(s, i, o) {
        return this[r].call(this, t, s, i, o);
      },
      configurable: !0
    });
  });
}
let W = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const s = this;
    function i(u, h, f) {
      const d = B(h);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const l = a.findKey(s, d);
      (!l || s[l] === void 0 || f === !0 || f === void 0 && s[l] !== !1) && (s[l || h] = j(u));
    }
    const o = (u, h) => a.forEach(u, (f, d) => i(f, d, h));
    return a.isPlainObject(t) || t instanceof this.constructor ? o(t, n) : a.isString(t) && (t = t.trim()) && !n1(t) ? o(e1(t), n) : t != null && i(n, t, r), this;
  }
  get(t, n) {
    if (t = B(t), t) {
      const r = a.findKey(this, t);
      if (r) {
        const s = this[r];
        if (!n)
          return s;
        if (n === !0)
          return t1(s);
        if (a.isFunction(n))
          return n.call(this, s, r);
        if (a.isRegExp(n))
          return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = B(t), t) {
      const r = a.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || G(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = B(o), o) {
        const u = a.findKey(r, o);
        u && (!n || G(r, r[u], u, n)) && (delete r[u], s = !0);
      }
    }
    return a.isArray(t) ? t.forEach(i) : i(t), s;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || G(this, this[i], i, t, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(t) {
    const n = this, r = {};
    return a.forEach(this, (s, i) => {
      const o = a.findKey(r, i);
      if (o) {
        n[o] = j(s), delete n[i];
        return;
      }
      const u = t ? r1(i) : String(i).trim();
      u !== i && delete n[i], n[u] = j(s), r[u] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return a.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = t && a.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(t) {
    const r = (this[he] = this[he] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(o) {
      const u = B(o);
      r[u] || (s1(s, o), r[u] = !0);
    }
    return a.isArray(t) ? t.forEach(i) : i(t), this;
  }
};
W.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
a.reduceDescriptors(W.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
a.freezeMethods(W);
const A = W;
function K(e, t) {
  const n = this || oe, r = t || n, s = A.from(r.headers);
  let i = r.data;
  return a.forEach(e, function(u) {
    i = u.call(n, i, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), i;
}
function ve(e) {
  return !!(e && e.__CANCEL__);
}
function v(e, t, n) {
  m.call(this, e ?? "canceled", m.ERR_CANCELED, t, n), this.name = "CanceledError";
}
a.inherits(v, m, {
  __CANCEL__: !0
});
function i1(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new m(
    "Request failed with status code " + n.status,
    [m.ERR_BAD_REQUEST, m.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
const o1 = R.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, s, i) {
      const o = [e + "=" + encodeURIComponent(t)];
      a.isNumber(n) && o.push("expires=" + new Date(n).toGMTString()), a.isString(r) && o.push("path=" + r), a.isString(s) && o.push("domain=" + s), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function a1(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function l1(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function He(e, t) {
  return e && !a1(t) ? l1(e, t) : t;
}
const c1 = R.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function s(i) {
      let o = i;
      return t && (n.setAttribute("href", o), o = n.href), n.setAttribute("href", o), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = s(window.location.href), function(o) {
      const u = a.isString(o) ? s(o) : o;
      return u.protocol === r.protocol && u.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
);
function u1(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function d1(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let s = 0, i = 0, o;
  return t = t !== void 0 ? t : 1e3, function(h) {
    const f = Date.now(), d = r[i];
    o || (o = f), n[s] = h, r[s] = f;
    let l = i, y = 0;
    for (; l !== s; )
      y += n[l++], l = l % e;
    if (s = (s + 1) % e, s === i && (i = (i + 1) % e), f - o < t)
      return;
    const w = d && f - d;
    return w ? Math.round(y * 1e3 / w) : void 0;
  };
}
function pe(e, t) {
  let n = 0;
  const r = d1(50, 250);
  return (s) => {
    const i = s.loaded, o = s.lengthComputable ? s.total : void 0, u = i - n, h = r(u), f = i <= o;
    n = i;
    const d = {
      loaded: i,
      total: o,
      progress: o ? i / o : void 0,
      bytes: u,
      rate: h || void 0,
      estimated: h && o && f ? (o - i) / h : void 0,
      event: s
    };
    d[t ? "download" : "upload"] = !0, e(d);
  };
}
const f1 = typeof XMLHttpRequest < "u", h1 = f1 && function(e) {
  return new Promise(function(n, r) {
    let s = e.data;
    const i = A.from(e.headers).normalize();
    let { responseType: o, withXSRFToken: u } = e, h;
    function f() {
      e.cancelToken && e.cancelToken.unsubscribe(h), e.signal && e.signal.removeEventListener("abort", h);
    }
    let d;
    if (a.isFormData(s)) {
      if (R.hasStandardBrowserEnv || R.hasStandardBrowserWebWorkerEnv)
        i.setContentType(!1);
      else if ((d = i.getContentType()) !== !1) {
        const [C, ...g] = d ? d.split(";").map((x) => x.trim()).filter(Boolean) : [];
        i.setContentType([C || "multipart/form-data", ...g].join("; "));
      }
    }
    let l = new XMLHttpRequest();
    if (e.auth) {
      const C = e.auth.username || "", g = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      i.set("Authorization", "Basic " + btoa(C + ":" + g));
    }
    const y = He(e.baseURL, e.url);
    l.open(e.method.toUpperCase(), ke(y, e.params, e.paramsSerializer), !0), l.timeout = e.timeout;
    function w() {
      if (!l)
        return;
      const C = A.from(
        "getAllResponseHeaders" in l && l.getAllResponseHeaders()
      ), x = {
        data: !o || o === "text" || o === "json" ? l.responseText : l.response,
        status: l.status,
        statusText: l.statusText,
        headers: C,
        config: e,
        request: l
      };
      i1(function(F) {
        n(F), f();
      }, function(F) {
        r(F), f();
      }, x), l = null;
    }
    if ("onloadend" in l ? l.onloadend = w : l.onreadystatechange = function() {
      !l || l.readyState !== 4 || l.status === 0 && !(l.responseURL && l.responseURL.indexOf("file:") === 0) || setTimeout(w);
    }, l.onabort = function() {
      l && (r(new m("Request aborted", m.ECONNABORTED, e, l)), l = null);
    }, l.onerror = function() {
      r(new m("Network Error", m.ERR_NETWORK, e, l)), l = null;
    }, l.ontimeout = function() {
      let g = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const x = e.transitional || Ie;
      e.timeoutErrorMessage && (g = e.timeoutErrorMessage), r(new m(
        g,
        x.clarifyTimeoutError ? m.ETIMEDOUT : m.ECONNABORTED,
        e,
        l
      )), l = null;
    }, R.hasStandardBrowserEnv && (u && a.isFunction(u) && (u = u(e)), u || u !== !1 && c1(y))) {
      const C = e.xsrfHeaderName && e.xsrfCookieName && o1.read(e.xsrfCookieName);
      C && i.set(e.xsrfHeaderName, C);
    }
    s === void 0 && i.setContentType(null), "setRequestHeader" in l && a.forEach(i.toJSON(), function(g, x) {
      l.setRequestHeader(x, g);
    }), a.isUndefined(e.withCredentials) || (l.withCredentials = !!e.withCredentials), o && o !== "json" && (l.responseType = e.responseType), typeof e.onDownloadProgress == "function" && l.addEventListener("progress", pe(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && l.upload && l.upload.addEventListener("progress", pe(e.onUploadProgress)), (e.cancelToken || e.signal) && (h = (C) => {
      l && (r(!C || C.type ? new v(null, e, l) : C), l.abort(), l = null);
    }, e.cancelToken && e.cancelToken.subscribe(h), e.signal && (e.signal.aborted ? h() : e.signal.addEventListener("abort", h)));
    const p = u1(y);
    if (p && R.protocols.indexOf(p) === -1) {
      r(new m("Unsupported protocol " + p + ":", m.ERR_BAD_REQUEST, e));
      return;
    }
    l.send(s || null);
  });
}, ee = {
  http: vt,
  xhr: h1
};
a.forEach(ee, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Ce = (e) => `- ${e}`, p1 = (e) => a.isFunction(e) || e === null || e === !1, je = {
  getAdapter: (e) => {
    e = a.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const s = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let o;
      if (r = n, !p1(n) && (r = ee[(o = String(n)).toLowerCase()], r === void 0))
        throw new m(`Unknown adapter '${o}'`);
      if (r)
        break;
      s[o || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(s).map(
        ([u, h]) => `adapter ${u} ` + (h === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = t ? i.length > 1 ? `since :
` + i.map(Ce).join(`
`) : " " + Ce(i[0]) : "as no adapter specified";
      throw new m(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: ee
};
function X(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new v(null, e);
}
function me(e) {
  return X(e), e.headers = A.from(e.headers), e.data = K.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), je.getAdapter(e.adapter || oe.adapter)(e).then(function(r) {
    return X(e), r.data = K.call(
      e,
      e.transformResponse,
      r
    ), r.headers = A.from(r.headers), r;
  }, function(r) {
    return ve(r) || (X(e), r && r.response && (r.response.data = K.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = A.from(r.response.headers))), Promise.reject(r);
  });
}
const ye = (e) => e instanceof A ? e.toJSON() : e;
function L(e, t) {
  t = t || {};
  const n = {};
  function r(f, d, l) {
    return a.isPlainObject(f) && a.isPlainObject(d) ? a.merge.call({ caseless: l }, f, d) : a.isPlainObject(d) ? a.merge({}, d) : a.isArray(d) ? d.slice() : d;
  }
  function s(f, d, l) {
    if (a.isUndefined(d)) {
      if (!a.isUndefined(f))
        return r(void 0, f, l);
    } else
      return r(f, d, l);
  }
  function i(f, d) {
    if (!a.isUndefined(d))
      return r(void 0, d);
  }
  function o(f, d) {
    if (a.isUndefined(d)) {
      if (!a.isUndefined(f))
        return r(void 0, f);
    } else
      return r(void 0, d);
  }
  function u(f, d, l) {
    if (l in t)
      return r(f, d);
    if (l in e)
      return r(void 0, f);
  }
  const h = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: u,
    headers: (f, d) => s(ye(f), ye(d), !0)
  };
  return a.forEach(Object.keys(Object.assign({}, e, t)), function(d) {
    const l = h[d] || s, y = l(e[d], t[d], d);
    a.isUndefined(y) && l !== u || (n[d] = y);
  }), n;
}
const Ue = "1.6.7", ae = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  ae[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const we = {};
ae.transitional = function(t, n, r) {
  function s(i, o) {
    return "[Axios v" + Ue + "] Transitional option '" + i + "'" + o + (r ? ". " + r : "");
  }
  return (i, o, u) => {
    if (t === !1)
      throw new m(
        s(o, " has been removed" + (n ? " in " + n : "")),
        m.ERR_DEPRECATED
      );
    return n && !we[o] && (we[o] = !0, console.warn(
      s(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, o, u) : !0;
  };
};
function C1(e, t, n) {
  if (typeof e != "object")
    throw new m("options must be an object", m.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = t[i];
    if (o) {
      const u = e[i], h = u === void 0 || o(u, i, e);
      if (h !== !0)
        throw new m("option " + i + " must be " + h, m.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new m("Unknown option " + i, m.ERR_BAD_OPTION);
  }
}
const te = {
  assertOptions: C1,
  validators: ae
}, N = te.validators;
let V = class {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new fe(),
      response: new fe()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let s;
        Error.captureStackTrace ? Error.captureStackTrace(s = {}) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = L(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && te.assertOptions(r, {
      silentJSONParsing: N.transitional(N.boolean),
      forcedJSONParsing: N.transitional(N.boolean),
      clarifyTimeoutError: N.transitional(N.boolean)
    }, !1), s != null && (a.isFunction(s) ? n.paramsSerializer = {
      serialize: s
    } : te.assertOptions(s, {
      encode: N.function,
      serialize: N.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && a.merge(
      i.common,
      i[n.method]
    );
    i && a.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete i[p];
      }
    ), n.headers = A.concat(o, i);
    const u = [];
    let h = !0;
    this.interceptors.request.forEach(function(C) {
      typeof C.runWhen == "function" && C.runWhen(n) === !1 || (h = h && C.synchronous, u.unshift(C.fulfilled, C.rejected));
    });
    const f = [];
    this.interceptors.response.forEach(function(C) {
      f.push(C.fulfilled, C.rejected);
    });
    let d, l = 0, y;
    if (!h) {
      const p = [me.bind(this), void 0];
      for (p.unshift.apply(p, u), p.push.apply(p, f), y = p.length, d = Promise.resolve(n); l < y; )
        d = d.then(p[l++], p[l++]);
      return d;
    }
    y = u.length;
    let w = n;
    for (l = 0; l < y; ) {
      const p = u[l++], C = u[l++];
      try {
        w = p(w);
      } catch (g) {
        C.call(this, g);
        break;
      }
    }
    try {
      d = me.call(this, w);
    } catch (p) {
      return Promise.reject(p);
    }
    for (l = 0, y = f.length; l < y; )
      d = d.then(f[l++], f[l++]);
    return d;
  }
  getUri(t) {
    t = L(this.defaults, t);
    const n = He(t.baseURL, t.url);
    return ke(n, t.params, t.paramsSerializer);
  }
};
a.forEach(["delete", "get", "head", "options"], function(t) {
  V.prototype[t] = function(n, r) {
    return this.request(L(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
a.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, o, u) {
      return this.request(L(u || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  V.prototype[t] = n(), V.prototype[t + "Form"] = n(!0);
});
const U = V;
let m1 = class Ve {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners)
        return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((u) => {
        r.subscribe(u), i = u;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, t(function(i, o, u) {
      r.reason || (r.reason = new v(i, o, u), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Ve(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
};
const y1 = m1;
function w1(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function g1(e) {
  return a.isObject(e) && e.isAxiosError === !0;
}
const ne = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ne).forEach(([e, t]) => {
  ne[t] = e;
});
const b1 = ne;
function qe(e) {
  const t = new U(e), n = xe(U.prototype.request, t);
  return a.extend(n, U.prototype, t, { allOwnKeys: !0 }), a.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(s) {
    return qe(L(e, s));
  }, n;
}
const E = qe(oe);
E.Axios = U;
E.CanceledError = v;
E.CancelToken = y1;
E.isCancel = ve;
E.VERSION = Ue;
E.toFormData = z;
E.AxiosError = m;
E.Cancel = E.CanceledError;
E.all = function(t) {
  return Promise.all(t);
};
E.spread = w1;
E.isAxiosError = g1;
E.mergeConfig = L;
E.AxiosHeaders = A;
E.formToJSON = (e) => De(a.isHTMLForm(e) ? new FormData(e) : e);
E.getAdapter = je.getAdapter;
E.HttpStatusCode = b1;
E.default = E;
const {
  Axios: E1,
  AxiosError: _1,
  CanceledError: D1,
  isCancel: v1,
  CancelToken: H1,
  VERSION: j1,
  all: U1,
  Cancel: V1,
  isAxiosError: q1,
  spread: Z1,
  toFormData: $1,
  AxiosHeaders: z1,
  HttpStatusCode: W1,
  formToJSON: J1,
  getAdapter: G1,
  mergeConfig: K1
} = E, Ze = "https://api-gpt-staging.trava.finance", x1 = new E1({
  baseURL: Ze
});
async function S1(e, t) {
  return (await E({
    method: "post",
    url: Ze + "/chat",
    headers: {},
    data: {
      user_id: t,
      // user_id: "test",
      user_question: e
    }
  })).data.answer || "";
}
async function R1(e) {
  return (await x1.get(`/is_in_white_list/${e}`)).data;
}
const O1 = {
  0: {
    animation: !1,
    type: "answer",
    message: "Hello! How can I help you?",
    status: "SUCCESS"
  }
}, A1 = async (e) => new Promise((t) => {
  setTimeout(() => t(), e);
});
function T1({ address: e }) {
  const [t, n] = P(""), [r, s] = P(O1), [i, o] = P(!1), u = k(() => {
    let l = !1;
    return Object.values(r).forEach((y) => {
      y.animation && (l = !0);
    }), l;
  }, [r]), h = ge(null), f = async (l) => {
    if (u || t === "")
      return;
    const y = t;
    n(""), l.preventDefault();
    const w = Date.now();
    try {
      s((C) => ({
        ...C,
        [w]: {
          animation: !0,
          type: "question",
          message: y,
          status: "PROCESSING"
        }
      })), await A1(500), s((C) => ({
        ...C,
        [w + 1]: { animation: !1, type: "answer", message: "", status: "PROCESSING" }
      }));
      const p = await S1(y, e);
      s((C) => ({
        ...C,
        [w + 1]: {
          animation: !0,
          type: "answer",
          message: p,
          status: "SUCCESS"
        }
      }));
    } catch (p) {
      s((C) => {
        let g = { ...C };
        g[w].status = "FAILED", g[w].animation = !1;
        try {
          delete g[w + 1];
        } catch {
        }
        return d(), g;
      }), console.error(p);
    }
  }, d = be(() => {
    s((l) => {
      let y = {};
      return Object.entries(l).map(([w, p]) => {
        y[Number(w)] = {
          animation: !1,
          message: p.message,
          type: p.type,
          status: p.status
        };
      }), y;
    });
  }, []);
  return I(() => {
    var l;
    (l = h == null ? void 0 : h.current) == null || l.scrollIntoView();
  }, [r]), /* @__PURE__ */ c(ze, { children: /* @__PURE__ */ b(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        paddingLeft: 15,
        paddingBottom: 15,
        flexGrow: 1
      },
      children: [
        /* @__PURE__ */ c(
          "div",
          {
            style: {
              overflow: "hidden",
              position: "relative",
              width: "100%",
              height: "340px",
              paddingBottom: "10px"
            },
            children: /* @__PURE__ */ b(
              "div",
              {
                style: {
                  height: "100%",
                  overflowY: "auto",
                  scrollSnapType: "y mandatory"
                },
                children: [
                  Object.values(r).map((l, y) => /* @__PURE__ */ b(
                    "div",
                    {
                      style: {
                        ...l.type === "answer" && u && y + 1 === Object.values(r).length && {
                          scrollMarginBottom: "10px",
                          scrollSnapAlign: "end"
                        }
                      },
                      children: [
                        l.type === "question" && /* @__PURE__ */ c(nt, { message: l.message, state: l.status }),
                        l.type === "answer" && /* @__PURE__ */ c(
                          rt,
                          {
                            message: l.message,
                            animation: l.animation,
                            status: l.status,
                            typingSpeed: 20,
                            onAnimationEnd: () => {
                              d();
                            }
                          }
                        )
                      ]
                    },
                    y
                  )),
                  /* @__PURE__ */ c("div", { ref: h })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ b("div", { className: "input-container", children: [
          /* @__PURE__ */ c(Ee, { style: { width: "30px", height: "30px", marginLeft: "5px" } }),
          /* @__PURE__ */ c(
            "form",
            {
              onSubmit: (l) => {
                l.preventDefault(), f(l);
              },
              style: { flexGrow: 1 },
              children: /* @__PURE__ */ c(
                "input",
                {
                  className: "input",
                  type: "text",
                  value: t,
                  placeholder: "Write your message",
                  onChange: (l) => {
                    n(l.target.value);
                  },
                  style: {
                    border: "none",
                    width: "215px"
                  },
                  onFocus: () => o(!0),
                  onBlur: () => o(!1)
                }
              )
            }
          ),
          /* @__PURE__ */ c(
            "button",
            {
              id: "submit-button",
              onClick: f,
              type: "submit",
              className: "icon-button  " + (i ? "send-icon" : "send-icon-disabled"),
              style: {
                position: "absolute",
                right: 10,
                bottom: 5
              },
              disabled: i,
              children: /* @__PURE__ */ c(Ge, {})
            }
          )
        ] })
      ]
    }
  ) });
}
function F1() {
  return /* @__PURE__ */ b(
    "div",
    {
      style: {
        paddingLeft: "30px",
        paddingRight: "30px",
        paddingTop: "100px"
      },
      children: [
        /* @__PURE__ */ c("h3", { className: "text-color-2", children: "Sign In" }),
        /* @__PURE__ */ c("p", { className: "text-color-1", children: "Your wallet is not connected yet, please connect your wallet!" })
      ]
    }
  );
}
function N1() {
  return /* @__PURE__ */ c("div", { className: "info-container", children: /* @__PURE__ */ b("div", { children: [
    /* @__PURE__ */ c("h3", { children: "Register for the Whitelist" }),
    /* @__PURE__ */ b("p", { children: [
      "You are not in the whitelist, please",
      " ",
      /* @__PURE__ */ c(
        "a",
        {
          href: "https://docs.google.com/forms/d/e/1FAIpQLScrMe1WNvFDMPjD6zs8TMW5mW4IqbjyI9cGmKIK5odGh8SURQ/viewform",
          target: "_blank",
          children: "Register"
        }
      ),
      " ",
      "to use the ChatBot!"
    ] })
  ] }) });
}
function P1({ address: e }) {
  const [t, n] = P("IDLE"), r = be(async () => {
    if (e) {
      n("PROCESSING");
      try {
        const s = await R1(e);
        JSON.parse(s).is_in_white_list ? n("SUCCESS") : n("FAILED");
      } catch {
        n("FAILED");
      }
    }
  }, [e]);
  return I(() => {
    r();
  }, [r]), /* @__PURE__ */ b("div", { style: { height: "100%" }, children: [
    !e && /* @__PURE__ */ c(F1, {}),
    e && t === "FAILED" && /* @__PURE__ */ c(N1, {}),
    e && t === "SUCCESS" && /* @__PURE__ */ c(T1, { address: e }, e),
    e && t === "PROCESSING" && /* @__PURE__ */ c(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%"
        },
        children: /* @__PURE__ */ c(et, { style: { width: "24px", height: "24px" } })
      }
    )
  ] });
}
function L1({ address: e }) {
  return /* @__PURE__ */ c("div", { style: { height: "100%" }, children: /* @__PURE__ */ c(P1, { address: e }) });
}
function X1({ disabled: e, style: t, themeMode: n, address: r }) {
  const [s, i] = P(!1), o = ge(null), u = k(() => (t == null ? void 0 : t.width) || "350px", [t]), h = k(() => (t == null ? void 0 : t.height) || "470px", [t]), f = k(() => e ? !1 : s, [s, e]), d = k(() => n ? n === "dark" ? "dark" : "light" : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light", [n]), l = () => {
    i((w) => !w);
  }, y = () => {
    i(!1);
  };
  return /* @__PURE__ */ b("div", { className: `theme-${d}-mode`, style: { position: "relative", ...t ?? t }, children: [
    /* @__PURE__ */ c(
      "button",
      {
        ref: o,
        style: {
          padding: 0,
          width: f ? u : 58,
          height: f ? h : 59,
          borderRadius: f ? "12px" : "50%",
          transition: "all  0.3s ease-in-out",
          border: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#1C8CF3"
        },
        className: "remove-outline-on-focus",
        onClick: l,
        children: /* @__PURE__ */ c(
          "div",
          {
            style: {
              width: 72,
              height: 72
            },
            children: /* @__PURE__ */ c(
              Ke,
              {
                style: {
                  width: 72,
                  height: 72
                }
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ c(
      "div",
      {
        style: {
          width: f ? u : 58,
          height: f ? h : 59,
          visibility: f ? "initial" : "hidden",
          opacity: f ? 1 : 0,
          transition: "all  0.3s ease-in-out",
          bottom: "0px",
          right: "0px",
          position: "absolute",
          borderRadius: f ? "12px" : "50%",
          overflow: "hidden",
          boxShadow: f ? d === "dark" ? "0px 3px 6px 0px #00000014" : "0px 0px 6px 0px #d5d9d985 inset, 0px 3px 6px 0px #00000014" : ""
        },
        children: /* @__PURE__ */ b(
          "div",
          {
            style: {
              width: u,
              height: h,
              display: "flex",
              flexDirection: "column"
            },
            className: "chat-container",
            children: [
              /* @__PURE__ */ c(tt, { handleClose: y }),
              /* @__PURE__ */ c(L1, { address: r || "" })
            ]
          }
        )
      }
    )
  ] });
}
export {
  X1 as TravaGPTModal
};
